import React from 'react'

const PrimaryButton = ({href, text}) => {

  return (
    <>

    <a id="ll-link" className="ll-link" href={href}>{text}</a>

    </>
  )

  
}

export default PrimaryButton